import { useTranslation } from "react-i18next";
import PersonalInformationPreview from "./PersonalInformation/PersonalInformationPreview";
import EducationAndWorkTabPreview from "./EducationAndWork/EducationAndWorkTabPreview";
import PersonalTechSkillsTabPreview from "./PersonalAndTechSkills/PersonalTechSkillsTabPreview";
import AvailabilityAndConditionsTabPreview from "./AvailabilityAndConditions/AvailabilityAndConditionsTabPreview";
import GlobalClassificationTabPreview from "./GlobalClassification/GlobalClassificationTabPreview";
import ResumeTabPreview from "./Resume/ResumeTabPreview";

import { Tab, Nav } from "react-bootstrap";
import { useState } from "react";
import { ApplicationDetailsList } from "../ReApplications/InterviewDetailsList";
import newApplicationWarning from "../../../layout/others/exclamation_yellow_flat_icon.svg";
import DocumentsDetailSection from "../Documents/Simulations/DocumentsDetailSection";
import { useGeneralContext } from "../../General/Context";

export default function InterviewTabSection({
  interview,
  fromUrl,

  newApplicationAvailable
}) {
  let { t } = useTranslation();
  const [tabActive, setTabActive] = useState(0);
  const { userInformation } = useGeneralContext();
  const [updateDocumentsGrid, setUpdateDocumentsGrid] = useState(false);

  function refreshDocuments() {
    setUpdateDocumentsGrid(!updateDocumentsGrid);
  }
  const INTERVIEW = 1;
  return (
    <div className="card inboard">
      <Tab.Container defaultActiveKey="resume" id="interviews">
        <Nav variant="tabs" className="header-tabs">
          <Nav.Item>
            <Nav.Link eventKey="resume" onClick={() => setTabActive(0)}>
              {t("Overview")}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="personalInformation"
              onClick={() => setTabActive(1)}
            >
              {t("Personal Information")}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="educationWork" onClick={() => setTabActive(2)}>
              {t("Education & Work")}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="techSkill" onClick={() => setTabActive(3)}>
              {t("Personal & Tech Skills")}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="avaibilatyConditions"
              onClick={() => setTabActive(4)}
            >
              {t("Availability & Conditions")}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="globalClassification"
              onClick={() => setTabActive(5)}
            >
              {t("Global Classification")}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="documents">{t("Documents")}</Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link eventKey="applicationDetails">
              {t("Application Details")}
              {newApplicationAvailable && (
                <img
                  src={newApplicationWarning}
                  alt={t("new application available")}
                  title={t("new application available")}
                />
              )}
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="resume" className="card-body">
            {tabActive === 0 && <ResumeTabPreview interview={interview} />}
          </Tab.Pane>
          <Tab.Pane eventKey="personalInformation" className="card-body">
            {tabActive === 1 && (
              <PersonalInformationPreview interview={interview} />
            )}
          </Tab.Pane>
          <Tab.Pane eventKey="educationWork" className="card-body">
            {tabActive === 2 && (
              <EducationAndWorkTabPreview interview={interview} />
            )}
          </Tab.Pane>
          <Tab.Pane eventKey="techSkill" className="card-body">
            {tabActive === 3 && (
              <PersonalTechSkillsTabPreview interview={interview} />
            )}
          </Tab.Pane>
          <Tab.Pane eventKey="avaibilatyConditions" className="card-body">
            {tabActive === 4 && (
              <AvailabilityAndConditionsTabPreview interview={interview} />
            )}
          </Tab.Pane>
          <Tab.Pane eventKey="globalClassification" className="card-body">
            {tabActive === 5 && (
              <GlobalClassificationTabPreview interview={interview} />
            )}
          </Tab.Pane>
          <Tab.Pane eventKey="documents" className="card-body">
            <DocumentsDetailSection
              fromUrl={fromUrl}
              interview={interview}
              interviewId={interview.interviewId}
              permissions={userInformation.permissions}
              refreshDocuments={refreshDocuments}
              updateDocumentsGrid={updateDocumentsGrid}
            />
          </Tab.Pane>

          <Tab.Pane eventKey="applicationDetails">
            <div className="col-8 p-2">
              <ApplicationDetailsList
                list={interview.applicationDetails}
                activeId={interview.applicationDetailId}
                errors={{}}
                viewMode={true}
                interview={interview}
              />
            </div>
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  );
}
